export const REALTIME_IDLE_TIMEOUT_MS = 5 * 60 * 1000;

export const isOpenConversationPath = (pathname: string): boolean =>
	/^\/messages\/[^/]+\/?$/.test(pathname);

export const getRealtimeIdleDelay = ({
	pathname,
	now,
	lastActivityAt,
}: {
	pathname: string;
	now: number;
	lastActivityAt: number;
}): number | null => {
	if (isOpenConversationPath(pathname)) {
		return null;
	}

	return Math.max(0, REALTIME_IDLE_TIMEOUT_MS - (now - lastActivityAt));
};
